import { memo, forwardRef, useEffect } from "react";
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { getFundOverview } from "../../../redux/actions/mutualFund";
import Holdings from "./Holdings";
import { BzChip, BzButton } from '../../../components';
import BenchmarkPerformance from "./BenchmarkPerformance";
import FundOverview from './FundOverview';
import Companies from "./Companies";

const arrKababDropdown = [{ id: '0', value: '0', content: 'Redeem' }, { id: '1', value: '1', content: 'Start SWP' }, { id: '2', value: '2', content: 'Start STP' }, { id: '3', value: '3', content: 'Switch' },];
const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));

const Overview = ({ setShowOverview, handleOnShowFundOverView, fundOverview, ...props }) => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getFundOverview());
    }, [dispatch]);
    const handleOnCloseOverview = () => {

        setShowOverview(false);
    };

    return (
        <>
            <Container fluid className='p-0 px-4'>
                <Row className='g-0 py-4 bdr-btm'>
                    <Col className='d-flex justify-content-start align-items-center '>
                        <div className='icon-20 icon-arrowleft icon-dark' onClick={handleOnCloseOverview}></div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <div className='icon-20 icon-close icon-dark' onClick={handleOnCloseOverview}></div>
                    </Col>
                </Row>
                <Row className='g-0 py-3'>
                    <Col md={8}>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size6 color-text pe-3'>{fundOverview?.fundName}</div>
                                <div className='chips-wrap flex-wrap pe-3'>
                                    {fundOverview?.category.map((category, index) => {
                                        return <BzChip key={index} className='chips primary-chip text-uppercase me-2'>{category}</BzChip>;
                                    })}
                                </div>
                                <div className='d-flex justify-content-end align-items-center'>
                                    <div className='icon-20 icon-add-circle icon-dark'>&nbsp;</div>
                                    <div className='font-medium font-size4 color-text ms-2'>Add to Watchlist</div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4} className='flex-column align-items-center align-self-center ps-2'>
                        <Row className='g-0 w-100'>
                            <Col md={7} className='d-flex align-items-center justify-content-start'>
                                <div className='font-regular font-size4 color-subtext pe-1'>NAV:</div>
                                <div className='font-regular font-size4 color-text'>&#8377;{fundOverview.nav} </div>
                                <div className='icon-16 icon-info icon-dark ms-2'></div>
                            </Col>
                            <Col md={5} className='d-flex align-items-center justify-content-end'>
                                <BzButton className='btn btn-md btn-outline me-2'>SIP</BzButton>
                                <BzButton className='btn btn-md btn-positive me-2'>BUY</BzButton>
                                <div>
                                    <Dropdown className='dropdown-kebab' {...props}>
                                        <Dropdown.Toggle as={CustomDropdownToggle} className='p-0 m-0'>
                                            <div className='icon-16 icon-kebab icon-dark'></div>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {
                                                arrKababDropdown?.map((eachOption) => (
                                                    <Dropdown.Item key={eachOption.id} value={eachOption.value}>
                                                        <Container fluid className='p-0'>
                                                            <Row className='g-0' >
                                                                <Col md={eachOption?.shortcut ? 7 : 12} className='d-flex justify-content-start align-self-center'>
                                                                    <div className='font-regular font-size2 color-text text-nowrap text-truncate'>{eachOption.content}</div>
                                                                </Col>
                                                                {
                                                                    eachOption?.shortcut &&
                                                                    <Col md={5} className='d-flex justify-content-end align-self-center'>
                                                                        <div className='font-regular font-size2 color-text'>{eachOption.shortcut}</div>
                                                                    </Col>
                                                                }
                                                            </Row>
                                                        </Container>
                                                    </Dropdown.Item>
                                                ))
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                <div className='font-regular font-size2 color-subtext'>Nav as on 14 Feb 2023</div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='mt-3 g-0'>
                    <Col md={8} className='bdr-rgt pe-4'>
                        <BenchmarkPerformance />
                        <FundOverview fundOverview={fundOverview} />
                    </Col>
                    <Col md={4}>
                        <Holdings sector={fundOverview?.sector} holdings={fundOverview?.holdings}
                            handleOnShowFundOverView={handleOnShowFundOverView} />
                        <Companies companies={fundOverview?.companies}
                            handleOnShowFundOverView={handleOnShowFundOverView} />
                    </Col>
                </Row>
            </Container>
        </>
    );

};

export default memo(Overview);